import React from 'react';
import Helper from '../../helpers';
import { loadStripe } from '@stripe/stripe-js';
import RedirectFlow from '../../components/stripe/RedirectFlow';
import { Elements } from '@stripe/react-stripe-js';

const params = Helper.getUrlParams();
const RedirectStripePaymentScreen = ({ history }) => {
    const { pubKey, setup_intent_client_secret } = params;
    const stripePromise = loadStripe(pubKey);

    return (
        <Elements stripe={stripePromise}>
            <RedirectFlow clientSecret={setup_intent_client_secret} history={history} />
        </Elements>
    );
};

export default RedirectStripePaymentScreen;
